'use client';
import Box from '@mui/material/Box';
import {styled} from '@mui/material/styles';
import {useTranslation} from 'react-i18next';
import {BaseModal} from '../primitives';
import {AmenityChip, type AmenityChipProps} from './AmenityChip';

export interface AmenitiesModalProps {
  open: boolean;
  onClose: () => void;
  items: AmenityChipProps[];
}

const ItemsGrid = styled(Box)(({theme}) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: theme.spacing(1.5),
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
}));

export function AmenitiesModal({open, onClose, items}: AmenitiesModalProps) {
  const {t} = useTranslation();

  return (
    <BaseModal open={open} onClose={onClose} title={t('amenities')} maxWidth={600} fadeOverflow>
      <ItemsGrid>
        {items.map((item, index) => (
          <AmenityChip key={`${item.label}-${index}`} icon={item.icon} label={item.label} />
        ))}
      </ItemsGrid>
    </BaseModal>
  );
}

AmenitiesModal.displayName = 'AmenitiesModal';
